/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateBatteryDto
 */
export interface CreateUpdateBatteryDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateBatteryDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateBatteryDto
     */
    description?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateBatteryDto
     */
    tests: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateBatteryDto
     */
    articlePsychologistsIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateBatteryDto
     */
    articleDoctorsIds?: Array<string> | null;
}

/**
 * Check if a given object implements the CreateUpdateBatteryDto interface.
 */
export function instanceOfCreateUpdateBatteryDto(value: object): value is CreateUpdateBatteryDto {
    if (!('tests' in value) || value['tests'] === undefined) return false;
    return true;
}

export function CreateUpdateBatteryDtoFromJSON(json: any): CreateUpdateBatteryDto {
    return CreateUpdateBatteryDtoFromJSONTyped(json, false);
}

export function CreateUpdateBatteryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateBatteryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'tests': json['tests'],
        'articlePsychologistsIds': json['articlePsychologistsIds'] == null ? undefined : json['articlePsychologistsIds'],
        'articleDoctorsIds': json['articleDoctorsIds'] == null ? undefined : json['articleDoctorsIds'],
    };
}

export function CreateUpdateBatteryDtoToJSON(value?: CreateUpdateBatteryDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'tests': value['tests'],
        'articlePsychologistsIds': value['articlePsychologistsIds'],
        'articleDoctorsIds': value['articleDoctorsIds'],
    };
}

